import React from 'react';
import Icon from '../openplay/OpenPlayIcon';
import PlaceListItem from './PlaceListItem';
import EventListItem from './EventListItem';
import PanelEmptyState from './PanelEmptyState';

const MobileMapListPanel = ({
  isOpen,
  mapSideTab,
  onChangeTab,
  onClose,
  placeList,
  listEvents,
  userLocation,
  getEventTypeIconLabel,
  eventTypeStyles,
  fallbackEventImage,
  onLocatePlace,
  onLocateEvent,
  onApplyEvent,
  onShareEvent,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] lg:hidden">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      <div className="absolute left-0 right-0 bottom-0 max-h-[96dvh] bg-white rounded-t-2xl border-t border-border shadow-elevation-4 overflow-hidden flex flex-col min-h-0">
        <div className="flex items-center justify-between px-4 py-2 border-b border-border">
          <p className="text-sm font-semibold text-foreground">지도 목록</p>
          <button
            type="button"
            className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-muted transition-smooth flex items-center justify-center text-muted-foreground hover:text-foreground"
            aria-label="닫기"
            onClick={onClose}
          >
            <Icon name="XMarkIcon" size={20} />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain" style={{ paddingBottom: 'calc(84px + env(safe-area-inset-bottom, 16px))' }}>
          <div className="px-4 pt-4">
            <div className="flex items-center gap-2 bg-muted/40 p-1 rounded-full">
              <button
                type="button"
                onClick={() => onChangeTab('events')}
                className={`flex-1 h-9 rounded-full text-xs font-semibold transition-smooth ${
                  mapSideTab === 'events' ? 'bg-white text-foreground shadow-elevation-1' : 'text-muted-foreground'
                }`}
              >
                <span className="inline-flex items-center gap-1">
                  <Icon name="CalendarIcon" size={14} />
                  진행중 이벤트 ({listEvents.length})
                </span>
                {mapSideTab === 'events' && <span className="block mt-1 h-0.5 bg-primary rounded-full" />}
              </button>
              <button
                type="button"
                onClick={() => onChangeTab('places')}
                className={`flex-1 h-9 rounded-full text-xs font-semibold transition-smooth ${
                  mapSideTab === 'places' ? 'bg-white text-foreground shadow-elevation-1' : 'text-muted-foreground'
                }`}
              >
                <span className="inline-flex items-center gap-1">
                  <Icon name="MapPinIcon" size={14} />
                  등록된 장소 ({placeList.length})
                </span>
                {mapSideTab === 'places' && <span className="block mt-1 h-0.5 bg-primary rounded-full" />}
              </button>
            </div>
          </div>

          {mapSideTab === 'places' && (
            <>
              {placeList.length === 0 ? (
                <PanelEmptyState message="등록된 장소가 없습니다." />
              ) : (
                <ul className="divide-y divide-border">
                  {placeList.map((place) => (
                    <PlaceListItem key={place.id} place={place} onLocate={() => onLocatePlace(place)} />
                  ))}
                </ul>
              )}
            </>
          )}

          {mapSideTab === 'events' && (
            <>
              {listEvents.length === 0 ? (
                <PanelEmptyState message="표시할 이벤트가 없습니다." />
              ) : (
                <ul className="divide-y divide-border">
                  {listEvents.map((event) => (
                    <EventListItem
                      key={event.id}
                      event={event}
                      fallbackEventImage={fallbackEventImage}
                      userLocation={userLocation}
                      getEventTypeIconLabel={getEventTypeIconLabel}
                      eventTypeStyles={eventTypeStyles}
                      onLocate={() => onLocateEvent(event)}
                      onApply={onApplyEvent}
                      onShare={onShareEvent}
                    />
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMapListPanel;
